import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

/**
 * Guards routes that should only be accessible to arkx_admin users.
 * Redirects non-admin users to /dashboard.
 */
export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuthStore();

  if (user && user.role !== 'arkx_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
